export const LiveVideoIcon = ({
  color = 'white',
  size = 30,
  className,
}: {
  color?: string
  size?: number
  className?: string
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
      className={className}
    >
      <g>
        <path
          d="M22 15V18C22 20.2091 20.2091 22 18 22H12C9.79086 22 8 20.2091 8 18V12C8 9.79086 9.79086 8 12 8H15"
          stroke="white"
          strokeLinecap="round"
        />
        <path
          d="M19.8536 7.31687C19.9113 7.19201 20.0887 7.19201 20.1464 7.31687L20.9233 8.9979C20.9394 9.03267 20.9673 9.06059 21.0021 9.07666L22.6831 9.85356C22.808 9.91126 22.808 10.0887 22.6831 10.1464L21.0021 10.9233C20.9673 10.9394 20.9394 10.9673 20.9233 11.0021L20.1464 12.6831C20.0887 12.808 19.9113 12.808 19.8536 12.6831L19.0767 11.0021C19.0606 10.9673 19.0327 10.9394 18.9979 10.9233L17.3169 10.1464C17.192 10.0887 17.192 9.91126 17.3169 9.85356L18.9979 9.07666C19.0327 9.06059 19.0606 9.03267 19.0767 8.9979L19.8536 7.31687Z"
          fill="white"
        />
        <path
          d="M17.7 14.7506C17.8333 14.8276 17.8333 15.0201 17.7 15.097L13.8 17.3487C13.6667 17.4257 13.5 17.3295 13.5 17.1755V12.6722C13.5 12.5182 13.6667 12.422 13.8 12.499L17.7 14.7506Z"
          stroke="white"
        />
      </g>
    </svg>
  )
}
